import PrivateRoute from '../../components/PrivateRoute'

// Páginas de Funções (Roles)
import CreateRolePage from '../../pages/roles/CreateRolePage'
import EditRolePage from '../../pages/roles/EditRolePage'
import RolePage from '../../pages/roles/RolesPage'

// Páginas de Fornecedores
import DetailsSupplierPage from '../../pages/equipments/suppliers/DetailsSupplierPage'
import SuppliersPage from '../../pages/equipments/suppliers/SuppliersPage'
import SupplierAddressDetailsPage from '../../pages/equipments/suppliers/address/SupplierAddressDetailsPage'
import SupplierContactDetailsPage from '../../pages/equipments/suppliers/contact/SupplierContactDetailsPage'

// Páginas de Unidades
import CreateUnitPage from '../../pages/equipments/units/CreateUnitPage'
import EditUnitPage from '../../pages/equipments/units/EditUnitPage'
import UnitPage from '../../pages/equipments/units/UnitPage'
import AttachUnitsRelatedPage from '../../pages/equipments/units/unitsRelated/AttachUnitsRelatedPage'

// Paginas de Kit
import CreateKitPage from '../../pages/equipments/kits/CreateKitPage'
import EditKitPage from '../../pages/equipments/kits/EditKitPage'
import KitPage from '../../pages/equipments/kits/KitPage'
import CreateKitItemPage from '../../pages/equipments/kits/items/CreateKitItemPage'
import KitItemsPage from '../../pages/equipments/kits/items/KitItemsPage'
import EditKitItemPage from '../../pages/equipments/kits/items/EditKitItemPage'

// Páginas de Equipamentos
import CreateEquipmentPage from '../../pages/equipments/equipment/CreateEquipmentPage'
import DetailsEquipmentPage from '../../pages/equipments/equipment/DetailsEquipmentPage'
import EditEquipmentPage from '../../pages/equipments/equipment/EditEquipmentPage'
import EquipmentPage from '../../pages/equipments/equipment/EquipmentPage'
import EquipmentToBeDisposalPage from '../../pages/equipments/equipment/EquipmentToBeDisposalPage'

// Páginas de Clientes
import CustomerPage from '../../pages/users/costumer/CustomerPage'
import CreateCustomerPage from '../../pages/users/costumer/CreateCustomerPage'
import CustomerDetailsPage from '../../pages/users/costumer/CustomerDetailsPage'
import EditCustomerPage from '../../pages/users/costumer/EditCustomerPage'
import CustomerAddressDetailsPage from '../../pages/users/costumer/address/CustomerAddressDetailsPage'
import CreateCustomerAddressPage from '../../pages/users/costumer/address/CreateCustomerAddressPage'
import EditCustomerAddressPage from '../../pages/users/costumer/address/EditCustomerAddressPage'
import CreateCustomerContactPage from '../../pages/users/costumer/contact/CreateCustomerContactPage'
import EditCustomerContactPage from '../../pages/users/costumer/contact/EditCustomerContactPage'
import CreateCustomerLocationPage from '../../pages/users/costumer/locations/CreateCustomerLocationPage'
import EditCustomerLocationPage from '../../pages/users/costumer/locations/EditCustomerLocationPage'
import DetailsCustomerLocationPage from '../../pages/users/costumer/locations/DetailsCustomerLocationPage'
import LocationCustomerPage from '../../pages/users/costumer/locations/LocationCustomerPage'

// Páginas de Contratos e Status
import ContractPage from '../../pages/contracts/contract/ContractPage'
import CreateContractPage from '../../pages/contracts/contract/CreateContractPage'
import DetailsContractPage from '../../pages/contracts/contract/DetailsContractPage'
import EditContractPage from '../../pages/contracts/contract/EditContractPage'

// Páginas de Movimentos
import CreateMovementPage from '../../pages/Movements/Movement/CreateMovementPage'
import DetailsMovementPage from '../../pages/Movements/Movement/DetailsMovementPage'
import EditMovementPage from '../../pages/Movements/Movement/EditMovementPage'
import AddMovementItemPage from '../../pages/Movements/Movement/Items/AddMovementItemPage'
import MovementsPage from '../../pages/Movements/Movement/MovementsPage'

// Páginas de Movimentos de Carregamentos
import DetailsShipmentItemPage from '../../pages/Movements/shipments/items/DetailsShipmentItemPage'
import EditShipmentItemPage from '../../pages/Movements/shipments/items/EditShipmentItemPage'

// Páginas de Ordem de Serviço
import DetailsOrderServicesPage from '../../pages/orderService/OrderService/DetailsOrderServicesPage'
import EditOrderServicePage from '../../pages/orderService/OrderService/EditOrderServicePage'
import CreateOrderServicePage from '../../pages/orderService/OrderService/CreateOrderServicePage'
import OrdersServicesPage from '../../pages/orderService/OrderService/OrdersServicesPage'
import DetailsItemOrderServicePage from '../../pages/orderService/OrderService/items/DetailsItemOrderServicePage'

// Páginas de Envios
import ShipmentsPage from '../../pages/Movements/shipments/ShipmentsPage'

// Páginas de Eventos
import CreateEventContractPage from '../../pages/contracts/event/CreateEventContractPage'
import DetailsEventContractPage from '../../pages/contracts/event/DetailsEventContractPage'
import EditEventContractPage from '../../pages/contracts/event/EditEventContractPage'
import HistoryEventsContractPage from '../../pages/contracts/event/HistoryEventsContractPage'
import CreateEventItemContractPage from '../../pages/contracts/event/items/CreateEventItemContractPage'
import EditEventItemContractPage from '../../pages/contracts/event/items/EditEventItemContractPage'
import CreateEventJobContractPage from '../../pages/contracts/event/jobs/CreateEventJobContractPage'
import EditEventJobContractPage from '../../pages/contracts/event/jobs/EditEventJobContractPage'

import DetailsMaintenanceMovementPage from '../../pages/equipments/equipment/maintenance/DetailsMaintenanceMovementPage'
import FixEquipment from '../../pages/equipments/fix-equipment/FixEquipment'

// * Relatórios
import EquipmentByContract from '../../pages/Relatorios/EquipmentByContract/EquipmentByContract'
import EquipmentByCustomer from '../../pages/Relatorios/EquipmentByCustomer/EquipmentByCustomer'
import EquipmentInStock from '../../pages/Relatorios/EquipmentInStock/EquipmentInStock'
import PerformaceTechnicians from '../../pages/Relatorios/PerformaceTechnicians/PerformaceTechnicians'
import Maintenances from '../../pages/Relatorios/Maintenances/Maintenances'
import CreateShipmentsPage from '../../pages/Movements/shipments/CreateShipmentsPage'
import ValidateShipmentsPage from '../../pages/Movements/shipments/ValidateShipmentsPage'
import EditShipmentsPage from '../../pages/Movements/shipments/EditShipmentsPage'
import DetailsShipmentsPage from '../../pages/Movements/shipments/DetailsShipmentsPage'
import ConfirmShipmentsPage from '../../pages/Movements/shipments/ConfirmShipmentsPage'
import ScannerEquipmentPage from '../../pages/equipments/equipment/ScannerEquipmentPage'
import AttachContractOrderServicePage from '../../pages/orderService/OrderService/AttachContractOrderServicePage'
import AddItemOrderServicePage from '../../pages/orderService/OrderService/items/AddItemOrderServicePage'
import LogisticsReport from '../../pages/Relatorios/Logistics/Logistics'
import ContractsReport from '../../pages/Relatorios/Contracts/Contracts'

const RoutesAluguel = {
  roles: [
    {
      path: '/aluguel/cargos',
      element: <PrivateRoute element={RolePage} />,
    },
    {
      path: '/aluguel/cargos/criar',
      element: <PrivateRoute element={CreateRolePage} />,
    },
    {
      path: '/aluguel/cargos/editar/:roleId',
      element: <PrivateRoute element={EditRolePage} />,
    },
  ],

  suppliers: [
    {
      path: '/aluguel/fornecedores',
      element: <PrivateRoute element={SuppliersPage} />,
    },
    {
      path: '/aluguel/fornecedores/detalhes/:id',
      element: <PrivateRoute element={DetailsSupplierPage} />,
    },
    {
      path: '/aluguel/fornecedores/:id/endereco/:addressId/detalhes',
      element: <PrivateRoute element={SupplierAddressDetailsPage} />,
    },
    {
      path: '/aluguel/fornecedores/:id/contato/:contactId/detalhes',
      element: <PrivateRoute element={SupplierContactDetailsPage} />,
    },
  ],

  equipments: [
    {
      path: '/aluguel/equipamentos',
      element: <PrivateRoute element={EquipmentPage} />,
    },
    {
      path: '/aluguel/equipamentos-para-baixa',
      element: <PrivateRoute element={EquipmentToBeDisposalPage} />,
    },
    {
      path: '/aluguel/escanear-equipamentos',
      element: <PrivateRoute element={ScannerEquipmentPage} />,
    },
    {
      path: '/aluguel/equipamentos/criar',
      element: <PrivateRoute element={CreateEquipmentPage} />,
    },
    {
      path: '/aluguel/equipamentos/editar/:id',
      element: <PrivateRoute element={EditEquipmentPage} />,
    },
    {
      path: '/aluguel/equipamentos/detalhes/:id',
      element: <PrivateRoute element={DetailsEquipmentPage} />,
    },
    {
      path: '/aluguel/equipamentos/corrigir-tombo',
      element: <PrivateRoute element={FixEquipment} />,
    },
    {
      path: '/aluguel/unidades',
      element: <PrivateRoute element={UnitPage} />,
    },
    {
      path: '/aluguel/unidades/criar',
      element: <PrivateRoute element={CreateUnitPage} />,
    },
    {
      path: '/aluguel/unidades/editar/:id',
      element: <PrivateRoute element={EditUnitPage} />,
    },
    {
      path: '/aluguel/unidades/:unitId/unidades-relacionadas/associar',
      element: <PrivateRoute element={AttachUnitsRelatedPage} />,
    },
    {
      path: '/aluguel/kits-equipamentos',
      element: <PrivateRoute element={KitPage} />,
    },
    {
      path: '/aluguel/kits-equipamentos/criar',
      element: <PrivateRoute element={CreateKitPage} />,
    },
    {
      path: '/aluguel/kits-equipamentos/editar/:equipmentKitId',
      element: <PrivateRoute element={EditKitPage} />,
    },
    {
      path: '/aluguel/kits-equipamentos/:equipmentKitId/itens',
      element: <PrivateRoute element={KitItemsPage} />,
    },
    {
      path: '/aluguel/kits-equipamentos/:equipmentKitId/itens/adicionar',
      element: <PrivateRoute element={CreateKitItemPage} />,
    },
    {
      path: '/aluguel/kits-equipamentos/:equipmentKitId/itens/:itemId/editar',
      element: <PrivateRoute element={EditKitItemPage} />,
    },
    // TODO:  Criar página de detalhes do kit
    // {
    //   path: "/kits-equipamentos/:equipmentKitId/itens/:itemId/detalhes",
    //   element: <PrivateRoute element={DetailsKitItemPage} />,
    // },
  ],

  customers: [
    {
      path: '/aluguel/clientes',
      element: <PrivateRoute element={CustomerPage} />,
    },
    {
      path: '/aluguel/clientes/criar',
      element: <PrivateRoute element={CreateCustomerPage} />,
    },
    {
      path: '/aluguel/clientes/editar/:id',
      element: <PrivateRoute element={EditCustomerPage} />,
    },
    {
      path: '/aluguel/clientes/detalhes/:id',
      element: <PrivateRoute element={CustomerDetailsPage} />,
    },
    {
      path: '/aluguel/clientes/:id/endereco/adicionar',
      element: <PrivateRoute element={CreateCustomerAddressPage} />,
    },
    {
      path: '/aluguel/clientes/:id/endereco/:addressId/editar',
      element: <PrivateRoute element={EditCustomerAddressPage} />,
    },
    {
      path: '/aluguel/clientes/:id/endereco/:addressId/detalhes',
      element: <PrivateRoute element={CustomerAddressDetailsPage} />,
    },
    {
      path: '/aluguel/clientes/:id/endereco/:addressId/localizacoes',
      element: <PrivateRoute element={LocationCustomerPage} />,
    },
    {
      path: '/aluguel/clientes/:id/endereco/:addressId/localizacoes/adicionar',
      element: <PrivateRoute element={CreateCustomerLocationPage} />,
    },
    {
      path: '/aluguel/clientes/:id/endereco/:addressId/localizacoes/editar/:locationId',
      element: <PrivateRoute element={EditCustomerLocationPage} />,
    },
    {
      path: '/aluguel/clientes/:id/endereco/:addressId/localizacoes/detalhes/:locationId',
      element: <PrivateRoute element={DetailsCustomerLocationPage} />,
    },
    {
      path: '/aluguel/clientes/:id/contato/adicionar',
      element: <PrivateRoute element={CreateCustomerContactPage} />,
    },
    {
      path: '/aluguel/clientes/:customerId/contato/editar/:contactId',
      element: <PrivateRoute element={EditCustomerContactPage} />,
    },
  ],

  contracts: [
    {
      path: '/aluguel/contratos',
      element: <PrivateRoute element={ContractPage} />,
    },
    {
      path: '/aluguel/contratos/criar',
      element: <PrivateRoute element={CreateContractPage} />,
    },
    {
      path: '/aluguel/contratos/:contractId/editar/',
      element: <PrivateRoute element={EditContractPage} />,
    },
    {
      path: '/aluguel/contratos/:contractId/detalhes/',
      element: <PrivateRoute element={DetailsContractPage} />,
    },
    {
      path: '/aluguel/contratos/:contractId/eventos',
      element: <PrivateRoute element={HistoryEventsContractPage} />,
    },
    {
      path: '/aluguel/contratos/:contractId/eventos/adicionar',
      element: <PrivateRoute element={CreateEventContractPage} />,
    },
    {
      path: '/aluguel/contratos/:contractId/eventos/:eventId/editar',
      element: <PrivateRoute element={EditEventContractPage} />,
    },
    {
      path: '/aluguel/contratos/:contractId/eventos/:eventId/detalhes',
      element: <PrivateRoute element={DetailsEventContractPage} />,
    },
    {
      path: '/aluguel/contratos/:contractId/eventos/:eventId/aditivos/:additiveId/itens/adicionar',
      element: <PrivateRoute element={CreateEventItemContractPage} />,
    },
    {
      path: '/aluguel/contratos/:contractId/eventos/:eventId/aditivos/:additiveId/itens/:itemId/editar',
      element: <PrivateRoute element={EditEventItemContractPage} />,
    },
    {
      path: '/aluguel/contratos/:contractId/eventos/:eventId/aditivos/:additiveId/servicos/adicionar',
      element: <PrivateRoute element={CreateEventJobContractPage} />,
    },
    {
      path: '/aluguel/contratos/:contractId/eventos/:eventId/aditivos/:additiveId/servicos/:jobId/editar',
      element: <PrivateRoute element={EditEventJobContractPage} />,
    },
  ],

  ordersServicesRoutes: [
    {
      path: '/aluguel/requisicoes',
      element: <PrivateRoute element={OrdersServicesPage} />,
    },
    {
      path: '/aluguel/requisicoes/criar',
      element: <PrivateRoute element={CreateOrderServicePage} />,
    },
    {
      path: '/aluguel/requisicoes/:serviceOrderId/editar',
      element: <PrivateRoute element={EditOrderServicePage} />,
    },
    {
      path: '/aluguel/requisicoes/:id/detalhes',
      element: <PrivateRoute element={DetailsOrderServicesPage} />,
    },
    {
      path: '/aluguel/requisicoes/:osId/itens/:itemId/detalhes',
      element: <PrivateRoute element={DetailsItemOrderServicePage} />,
    },
    {
      path: '/aluguel/requisicoes/:serviceOrderId/itens/adicionar',
      element: <PrivateRoute element={AddItemOrderServicePage} />,
    },
    {
      path: '/aluguel/requisicoes/:id/atrelar-contrato',
      element: <PrivateRoute element={AttachContractOrderServicePage} />,
    },
  ],

  movements: [
    {
      path: '/aluguel/movimentos',
      element: <PrivateRoute element={MovementsPage} />,
    },
    {
      path: '/aluguel/movimentos/criar',
      element: <PrivateRoute element={CreateMovementPage} />,
    },
    {
      path: '/aluguel/movimentos/editar/:movementId',
      element: <PrivateRoute element={EditMovementPage} />,
    },
    {
      path: '/aluguel/movimentos/detalhes/:movementId',
      element: <PrivateRoute element={DetailsMovementPage} />,
    },
    // Movimentos a partir de uma manutenção
    {
      path: '/aluguel/movimentos/manutenção/detalhes/:movementId',
      element: <PrivateRoute element={DetailsMaintenanceMovementPage} />,
    },
    {
      path: '/aluguel/movimentos/:movementId/itens/:osId/adicionar',
      element: <PrivateRoute element={AddMovementItemPage} />,
    },
  ],

  shipments: [
    {
      path: '/aluguel/carregamentos',
      element: <PrivateRoute element={ShipmentsPage} />,
    },
    {
      path: '/aluguel/carregamentos/validar',
      element: <PrivateRoute element={ValidateShipmentsPage} />,
    },
    {
      path: '/aluguel/carregamentos/criar',
      element: <PrivateRoute element={CreateShipmentsPage} />,
    },
    {
      path: '/aluguel/carregamentos/:shipmentId/editar',
      element: <PrivateRoute element={EditShipmentsPage} />,
    },
    {
      path: '/aluguel/carregamentos/:shipmentId/detalhes',
      element: <PrivateRoute element={DetailsShipmentsPage} />,
    },
    {
      path: '/aluguel/carregamentos/:shipmentId/confirmar',
      element: <PrivateRoute element={ConfirmShipmentsPage} />,
    },
    {
      path: '/aluguel/carregamentos/:shipmentId/itens/:itemId/editar',
      element: <PrivateRoute element={EditShipmentItemPage} />,
    },
    {
      path: '/aluguel/carregamentos/:shipmentId/itens/:itemId/detalhes',
      element: <PrivateRoute element={DetailsShipmentItemPage} />,
    },
  ],

  reports: [
    {
      path: '/aluguel/relatorio/contratos',
      element: <PrivateRoute element={ContractsReport} />,
    },
    {
      path: '/aluguel/relatorio/equipamentos-por-contrato',
      element: <PrivateRoute element={EquipmentByContract} />,
    },
    {
      path: '/aluguel/relatorio/equipamentos-por-cliente',
      element: <PrivateRoute element={EquipmentByCustomer} />,
    },
    {
      path: '/aluguel/relatorio/equipamentos-em-estoque',
      element: <PrivateRoute element={EquipmentInStock} />,
    },
    {
      path: '/aluguel/relatorio/manutencao',
      element: <PrivateRoute element={Maintenances} />,
    },
    {
      path: '/aluguel/relatorio/producao',
      element: <PrivateRoute element={PerformaceTechnicians} />,
    },
    {
      path: '/aluguel/relatorio/logistico',
      element: <PrivateRoute element={LogisticsReport} />,
    },
  ],
}

export default RoutesAluguel
